module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (options.showNavigationButtons) { 
__p+='\n<a class="fmcy-slider-control-prev" href="#" role="button">\n    <span class="fmcy-slider-control-prev-icon" aria-hidden="true"></span>\n    <span class="sr-only">Previous</span>\n</a>\n<a class="fmcy-slider-control-next" href="#" role="button">\n    <span class="fmcy-slider-control-next-icon" aria-hidden="true"></span>\n    <span class="sr-only">Next</span>\n</a>\n';
 } 
__p+='\n<div class="fmcy-loader-wrapper">\n    <div class="fmcy-loader-region"></div>\n</div>\n<div class="fmcy-slide-layer-a-region"></div>\n<div class="fmcy-slide-layer-b-region"></div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/slider/slider.html
 ** module id = 214
 ** module chunks = 1 2 3 4 5 6 7 10 11 22 85
 **/